// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const guestList_noGuestsYet = (i) => `No guests have responded yet. <br> But they will surely come.`